import * as React from 'react'

import WarningIcon from '@frontrow/console/src/components/common/warning-icon'
import * as style from './warning-message.module.scss'

type Props = {
  message: string
}

export default function WarningMessage(props: Props): React.ReactElement {
  const {message} = props

  return (
    <React.Fragment>
      <div className={style.messageWrapper}>
        <WarningIcon addClass={style.messageIcon} />
        <div className={style.messageText}>{message}</div>
      </div>
    </React.Fragment>
  )
}
